export default "__VITE_ASSET__DtCbvzz1__"